module.exports = __webpack_public_path__ + "media/assets/images/logo-31d16c9c54d13dc73c2a22461061e44c.png";